webpackJsonp([159829283826604],{

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(10);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _renderHtml = __webpack_require__(24);
	
	var _renderHtml2 = _interopRequireDefault(_renderHtml);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FAQs = function (_React$Component) {
	  _inherits(FAQs, _React$Component);
	
	  function FAQs(props) {
	    _classCallCheck(this, FAQs);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      n: 0
	    };
	    return _this;
	  }
	
	  FAQs.prototype.renderContent = function renderContent(content) {
	    return {
	      __html: content
	    };
	  };
	
	  FAQs.prototype.render = function render() {
	    var _this2 = this;
	
	    var data = this.props.data.allDatoCmsFaq;
	    return _react2.default.createElement(
	      "div",
	      { className: "FAQs" },
	      _react2.default.createElement("div", { className: "bg" }),
	      _react2.default.createElement(
	        "div",
	        { className: "internal" },
	        _react2.default.createElement(
	          "h4",
	          null,
	          "Frequently Asked Questions"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "items" },
	          data.edges.map(function (item, i) {
	            var _ClassNames;
	
	            return _react2.default.createElement(
	              "div",
	              {
	                className: (0, _classnames2.default)((_ClassNames = {
	                  item: true
	                }, _ClassNames["is-active"] = i === _this2.state.n, _ClassNames)),
	                key: i,
	                onClick: function onClick() {
	                  if (_this2.state.n !== i) {
	                    _this2.setState({ n: i });
	                  }
	                }
	              },
	              _react2.default.createElement(
	                "h5",
	                { className: "question" },
	                item.node.question
	              ),
	              _this2.state.n === i && _react2.default.createElement("div", {
	                className: "answer",
	                dangerouslySetInnerHTML: _renderHtml2.default.go(item.node.answer)
	              }),
	              _react2.default.createElement(
	                "div",
	                { className: "action" },
	                _this2.state.n === i && _react2.default.createElement(
	                  "span",
	                  {
	                    className: "action",
	                    onClick: function onClick(e) {
	                      _this2.setState({
	                        n: null
	                      });
	                    }
	                  },
	                  "-"
	                ),
	                _this2.state.n !== i && _react2.default.createElement(
	                  "span",
	                  { className: "action" },
	                  "+"
	                )
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return FAQs;
	}(_react2.default.Component);
	
	exports.default = FAQs;
	
	
	FAQs.propTypes = {
	  data: _propTypes2.default.shape({
	    allDatoCmsFaq: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	
	/* eslint no-undef: "off" */
	var query = exports.query = "** extracted graphql fragment **";

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = {
	  convert: function convert(content) {
	    content = content.replace("Yoga Flow", "Yoga Flow<span class='special'>➁</span>");
	    content = content.replace("Protein Joe", "Protein Joe<span class='special'>➁</span>");
	    return content;
	  },
	  go: function go(content) {
	    return {
	      __html: this.convert(content)
	    };
	  }
	};
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-faqs-js-29e3f1293ca0dc4f8da6.js